module.exports = __webpack_public_path__ + "media/iconic/document-37cde704.svg";